<app-modal-basic #modalRelatorio (closed)="destroyComponent()" [modalContentId]="'modal-premiacoes'">
  <div class="app-modal-header">
    <h4 class="modal-title">Premiações</h4>
  </div>
  <div class="app-modal-body">
    <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div class="form-group col-sm-12">
          <label>Período</label>
          <div class="input-group">
            <app-data [calendarPosition]="'left'" formControlName="periodoDe"></app-data>
            <span class="input-group-addon">até</span>
            <app-data formControlName="periodoAte"></app-data>
          </div>
          <div class='row'>
            <div class='col-sm-6'>
              <show-errors [control]="impressaoForm.controls.periodoDe"></show-errors>
            </div>
            <div class='col-sm-6'>
              <show-errors [control]="impressaoForm.controls.periodoAte"></show-errors>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12">
          <label>Contabilidade</label>
          <ng-select appendTo="#modal-premiacoes" #select [items]="contabilidadeOptions" formControlName="contabilidadeID"
            placeholder="Selecione" [virtualScroll]="true" bindLabel="nome" bindValue="id"
            (scrollToEnd)="fetchMore(select.searchTerm)" [loading]="loadingContabilidade"
            [typeahead]="contabilidadeInput">
          </ng-select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12">
          <div class="checkbox-fade fade-in-default">
            <label>
              <input type="checkbox" formControlName="apenasNaoPagos">
              <span class="cr">
                <i class="cr-icon icofont icofont-ui-check txt-default"></i>
              </span>
              <span>Apenas ainda não pagos</span>
            </label>
          </div>
        </div>
      </div>
      <button type="submit" (click)="validaForm()" class="btn btn-primary ripple light">
        <i class="icofont icofont-print"> </i> Imprimir
      </button>
      <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-close"></i>
        Cancelar
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
  </div>
</app-modal-basic>
